import './RecordReferences.scss';
import { AppCountTag, PicklistCountTag, PopulationPercentageTag, ReferenceCountTag, ReportCountTag } from '@ui/tags';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
export const SonarRecordReferences = ({ parentName = '', relatedCounts, sonarObjectId }) => {
    var _a, _b, _c;
    if (!relatedCounts) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ReferenceCountTag, { count: (_a = relatedCounts.fieldReferencesTotal) !== null && _a !== void 0 ? _a : 0 }),
        React.createElement(PicklistCountTag, { count: (_b = relatedCounts[SonarObjectType.SalesforcePicklistValue]) !== null && _b !== void 0 ? _b : 0 }),
        React.createElement(ReportCountTag, { count: (_c = relatedCounts[SonarObjectType.SalesforceReport]) !== null && _c !== void 0 ? _c : 0 }),
        React.createElement(PopulationPercentageTag, { parentName: parentName, percent: relatedCounts.populationPercentage }),
        React.createElement(FeatureBoundary, { feature: FeatureFlag.DataSecurityDashboard }, Boolean(sonarObjectId) && React.createElement(AppCountTag, { sonarObjectId: sonarObjectId }))));
};
